import PageGate from "../../../components/PageGate";
import { PERMS } from "../../../utils/perms";
import { useNavigate, useParams } from "react-router-dom";
import { useGetDepartmentQuery } from "../api/departmentsApi";

export default function DepartmentDetailsPage() {
  const navigate = useNavigate();
  const id = Number(useParams().id);

  const { data, isLoading, error, refetch } = useGetDepartmentQuery(id, {
    skip: !id,
  });

  return (
    <PageGate perm={PERMS.admin.detailsAccess}>
      <div className="bg-white border rounded-xl p-6">
        <div className="flex items-start justify-between gap-3">
          <div>
            <button
              onClick={() => navigate("/departments")}
              className="text-sm text-gray-600 hover:underline"
            >
              ← Back to Departments
            </button>

            <h1 className="text-xl font-bold text-gray-800 mt-2">
              Department Details
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              View department information.
            </p>
          </div>

          <button
            onClick={() => refetch()}
            className="px-4 py-2 rounded-lg border hover:bg-gray-50 text-sm"
          >
            Refresh
          </button>
        </div>

        {isLoading ? (
          <div className="mt-6 text-gray-600">Loading...</div>
        ) : error ? (
          <div className="mt-6 text-red-600">Failed to load department.</div>
        ) : !data ? (
          <div className="mt-6 text-gray-600">No data.</div>
        ) : (
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="border rounded-xl p-4">
              <div className="text-xs text-gray-500">Name</div>
              <div className="font-semibold text-gray-900 mt-1">
                {data.name}
              </div>
            </div>

            <div className="border rounded-xl p-4">
              <div className="text-xs text-gray-500">Code</div>
              <div className="font-semibold text-gray-900 mt-1">
                {data.code ?? "—"}
              </div>
            </div>

            <div className="border rounded-xl p-4">
              <div className="text-xs text-gray-500">Status</div>
              <div className="font-semibold text-gray-900 mt-1">
                {data.is_active === false ? "Inactive" : "Active"}
              </div>
            </div>

            <div className="border rounded-xl p-4 md:col-span-3">
              <div className="text-xs text-gray-500">Description</div>
              <div className="text-gray-800 mt-1">
                {data.description ?? "—"}
              </div>
            </div>
          </div>
        )}
      </div>
    </PageGate>
  );
}
